import React from 'react';
import styled from 'styled-components';
import {breakPoint} from '../styles/var';
import OuterLink from './OuterLink';
import Img from './Img';

// images
import mombaby_logo from '../assets/img/PC4-1.png';
import x from '../assets/img/PC4-2.png';
import chicco_logo from '../assets/img/PC4-3.png';
import {Container} from '../styles/Grids';

const FooterStyles = styled.footer`
  position: relative;
  background-color: var(--white);
  .sponsor {
    padding: 3rem 2rem 2rem;
    display: flex;
    gap: 1.5rem;
    justify-content: center;
    align-items: center;
    margin-left: auto;
    margin-right: auto;
  }
  .mombaby {
    max-width: 13rem;
  }
  .x {
    max-width: 2rem;
  }
  .chicco {
    max-width: 11rem;
  }
  @media (max-width: ${breakPoint.smMax}) {
    .sponsor {
      max-width: 28rem;
      padding-top: 2rem;
      padding-bottom: 1rem;
    }
    .mombaby {
      max-width: 11rem;
    }
    .x {
      max-width: 1.3rem;
    }
    .chicco {
      max-width: 9rem;
    }
  }
`

const CopyrightStyles = styled.div`
  --bg: var(--primary);
  padding: 1.5rem 2rem;
  background-color: var(--bg);
  @media (max-width: ${breakPoint.max}) {
    padding-top: 1rem;
    padding-bottom: 1rem;
    .mombaby {
      max-width: 8rem;
    }
  }
  @media (max-width: ${breakPoint.smMax}) {
    span {
      display: block;
    }
  }
`;

const Footer = () => {
  return (
    <FooterStyles>
      <div className="sponsor">
        <OuterLink href="https://www.mombaby.com.tw/">
          <Img src={mombaby_logo} auto wrapProps={{className: 'mombaby'}} />
        </OuterLink>
        <Img src={x} auto wrapProps={{className: 'x'}} />
        <OuterLink href="https://www.chicco.com.tw/">
          <Img src={chicco_logo} auto wrapProps={{className: 'chicco'}} />
        </OuterLink>
      </div>
      <CopyrightStyles className="center">
        Copyright {new Date().getFullYear()}.媽媽寶寶 All rights reserved. <span>版權所有，禁止擅自轉貼</span>
      </CopyrightStyles>
    </FooterStyles>
  )
}

export default Footer;
